import { categories, externalLinkAttrs } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full px-6 md:px-10 py-20 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-200/60 text-xs font-medium text-foreground-500 tracking-wide uppercase">
            All Categories
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Browse 14 Curated Collections
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            From streetwear to accessories, all links point to verified products on our main website
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              {...externalLinkAttrs}
              className="group flex flex-col rounded-lg bg-background-50 border border-background-200/60 hover:border-accent-300/50 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="h-40 md:h-44 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-7 h-7 flex items-center justify-center rounded-md bg-accent-100 group-hover:bg-accent-500 transition-colors">
                    <i className={`${cat.icon} text-sm text-accent-600 group-hover:text-white transition-colors`}></i>
                  </span>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {cat.description}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-foreground-400 group-hover:text-accent-600 transition-colors">
                  <span>Browse Collection</span>
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}